
/* ---- 00-base.js ---- */
/* ============================================================
   DEATHDOSE RESPAWN — v9 layer (13 Oct 2026). Built from build/v9/js/*.js
   by tools/build_v9.py into assets/respawn-v9.js (deferred, loaded by sections/respawn-nav.liquid
   after respawn.js and respawn-shopify.js). Each partial is its own IIFE and must not throw.
   ============================================================ */
window.DDv9=window.DDv9||{RM:!!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)};

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"00-base-js":"62c07c4d61"});

/* ---- 08-nav.js ---- */
/* v10 X3a — announcement strip rotation. Three messages, 4.5 s each, vertical slide.
   Pauses on hover/focus, when the tab is hidden and when the strip is collapsed/off-screen.
   Reduced motion: message 1 only, static (CSS also hides messages 2 and 3). Without JS message 1 shows. */
(function(){
  try{
    var box=document.querySelector('[data-dd-ann]'); if(!box) return;
    var ms=[].slice.call(box.querySelectorAll('[data-dd-ann-m]')); if(ms.length<2) return;
    var RM=!!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches);
    if(RM) return;
    var cur=0,timer=null,held=false,vis=true,user=false;
    function show(n){
      var prev=ms[cur]; cur=n;
      ms.forEach(function(m){ if(m!==ms[cur]&&m!==prev){ m.classList.remove('dd-ann-on','dd-ann-out'); } });
      prev.classList.remove('dd-ann-on'); prev.classList.add('dd-ann-out');
      var nx=ms[cur]; nx.classList.remove('dd-ann-out');
      /* snap the incoming message below the strip, then slide it in */
      nx.style.transition='none'; nx.classList.remove('dd-ann-on'); void nx.offsetWidth; nx.style.transition='';
      nx.classList.add('dd-ann-on');
      setTimeout(function(){ if(prev!==ms[cur]) prev.classList.remove('dd-ann-out'); },480);
    }
    function tick(){
      if(user||held||!vis||document.hidden) return;
      var nav=document.getElementById('nav'); if(nav&&nav.classList.contains('dd-is-stuck')) return;
      show((cur+1)%ms.length);
    }
    function start(){ if(!timer) timer=setInterval(tick,4500); }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    box.addEventListener('mouseenter',function(){ held=true; });
    box.addEventListener('mouseleave',function(){ held=false; });
    box.addEventListener('focusin',function(){ held=true; });
    box.addEventListener('focusout',function(){ held=false; });
    /* 25 Oct 2026: user pause/play (WCAG 2.2.2 — auto-updating content needs a pause control) */
    var pb=box.querySelector('[data-dd-ann-p]');
    if(pb){ pb.hidden=false; box.classList.add('dd-ann--ctl');
      pb.addEventListener('click',function(){ user=!user; pb.setAttribute('aria-pressed',user?'true':'false');
        pb.setAttribute('aria-label',user?'Play the rotating messages':'Pause the rotating messages'); }); }
    document.addEventListener('visibilitychange',function(){ if(document.hidden) stop(); else start(); });
    start();
  }catch(e){}
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"08-nav-js":"48f797c502"});

/* ---- 12-story.js ---- */
/* ============================================================
   12-story.js — v10 X1 (18 Oct 2026): "One last game" story (#story, [data-st])
   Each panel ([data-st-p]) gets .dd-st-on once when it enters the viewport (IntersectionObserver, never window
   scroll: Horizon can make .page-wrapper the scroll container). CSS then plays the figure fade/slide, the marker
   write-on and the P4 crack. Panels already scrolled past are revealed at once. Reduced motion or no IO: the
   section is never armed, so everything is visible and static. Test hook: window.__ddSt.all()
   ============================================================ */
(function(){
"use strict";
try{
  var roots=[].slice.call(document.querySelectorAll('[data-st]'));
  if(!roots.length) return;
  var panels=function(r){ return [].slice.call(r.querySelectorAll('[data-st-p]')); };
  var on=function(p){ p.classList.add('dd-st-on'); };
  window.__ddSt={all:function(){ roots.forEach(function(r){ panels(r).forEach(on); }); }};
  var rm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(rm||!('IntersectionObserver' in window)) return;
  roots.forEach(function(root){
    var ps=panels(root);
    if(!ps.length) return;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting||e.boundingClientRect.bottom<0){ on(e.target); io.unobserve(e.target); }
      });
    },{rootMargin:'0px 0px -26% 0px',threshold:0});
    ps.forEach(function(p){ io.observe(p); });
    root.classList.add('dd-st--arm');
  });
  window.addEventListener('beforeprint',window.__ddSt.all);
}catch(err){
  try{ [].forEach.call(document.querySelectorAll('.dd-st--arm'),function(r){ r.classList.remove('dd-st--arm'); }); }catch(e){}
}
})();
/* 24 Oct 2026: comic strip (all widths) — dots, arrows, "swipe" hint (hidden once the reader has swiped) */
(function(){
"use strict";
try{
  [].forEach.call(document.querySelectorAll('[data-st]'),function(root){
    var rail=root.querySelector('[data-st-rail]'), nav=root.querySelector('[data-st-nav]');
    if(!rail||!nav) return;
    var ps=[].slice.call(rail.querySelectorAll('[data-st-p]')), dots=[].slice.call(nav.querySelectorAll('.dd-st-dots i'));
    var prev=nav.querySelector('[data-st-prev]'), next=nav.querySelector('[data-st-next]'), hint=nav.querySelector('[data-st-hint]');
    function idx(){ return Math.round(rail.scrollLeft/Math.max(1,rail.clientWidth)); }
    function upd(){
      var i=Math.max(0,Math.min(ps.length-1,idx()));
      dots.forEach(function(d,k){ d.classList.toggle('is-on',k===i); });
      /* panels scrolled in sideways don't always trip the story's IntersectionObserver: reveal the current one here */
      if(ps[i]) ps[i].classList.add('dd-st-on');
      prev.disabled=i===0; next.disabled=i===ps.length-1;
      if(hint) hint.textContent=(i+1)+' / '+ps.length+(i===0?' \u00b7 swipe':'');
    }
    function go(d){
      var rm=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rail.scrollTo({left:(idx()+d)*rail.clientWidth,behavior:rm?'auto':'smooth'});
    }
    prev.addEventListener('click',function(){ go(-1); });
    next.addEventListener('click',function(){ go(1); });
    rail.addEventListener('keydown',function(e){ if(e.key==='ArrowRight'){go(1);e.preventDefault();} if(e.key==='ArrowLeft'){go(-1);e.preventDefault();} });
    var t=0; rail.addEventListener('scroll',function(){ clearTimeout(t); t=setTimeout(upd,60); },{passive:true});
    nav.hidden=false; upd();
  });
}catch(e){}
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"12-story-js":"3c71735abd"});

/* ---- 15-squad.js ---- */
/* ============================================================
   15-squad.js — Round 2, workstream R2-1 (15 Oct 2026)
   [01] Squad comms feed: loops the review cards right to left (CSS transform keyframe), measures one set so the
   loop is exact at any width, sets the speed to ~30 px/s, and pauses on: hover (desktop), keyboard focus on the
   track, a finger held down, off-screen, hidden tab, and the visible Pause/Play toggle (user). Tapping the track on
   a phone toggles the same user pause. Reduced motion: never starts (static snap row stays).
   Test hook: window.__ddSq2.state() / .toggle()
   ============================================================ */
(function(){
"use strict";
try{
  var roots=[].slice.call(document.querySelectorAll('[data-sq2]'));
  if(!roots.length) return;
  var SPEED=30;                       /* px per second */
  var mm=function(q){ return window.matchMedia?window.matchMedia(q):null; };
  var rm=mm('(prefers-reduced-motion: reduce)'), fine=mm('(hover: hover) and (pointer: fine)');

  function init(root){
    var view=root.querySelector('[data-sq2-view]'), track=root.querySelector('[data-sq2-track]'), btn=root.querySelector('[data-sq2-pp]');
    var sets=track?track.querySelectorAll('.dd-sq2-set'):[];
    if(!view||!track||sets.length<2) return null;
    var lab=btn?btn.querySelector('.dd-sq2-pp__t'):null;
    var live=false, dist=0, lastTouch=0, moved=false;
    var why={hover:0,focus:0,touch:0,off:0,hid:document.hidden?1:0,user:0};

    function paused(){ for(var k in why){ if(why[k]) return true; } return false; }
    function apply(){
      root.classList.toggle('dd-sq2--paused',live&&paused());
      /* 24 Oct 2026: the same button also stops the two squad member strips (they pause on their own hover/focus in CSS) */
      root.classList.toggle('dd-sqm--paused',live&&(why.user||why.off||why.hid)?true:false);
      if(btn){
        btn.setAttribute('aria-pressed',why.user?'true':'false');
        if(lab) lab.textContent=why.user?'Play feed':'Pause feed';
      }
    }
    function measure(){
      /* both sets share the track's transform, so the difference of their left edges is one exact set width */
      var d=sets[1].getBoundingClientRect().left-sets[0].getBoundingClientRect().left;
      if(!(d>40)) return;
      dist=d;
      root.style.setProperty('--sq2-dist',d.toFixed(2)+'px');
      root.style.setProperty('--sq2-dur',(d/SPEED).toFixed(2)+'s');
    }
    function start(){
      if(live) return;
      live=true; view.scrollLeft=0;
      root.classList.add('dd-sq2--live');
      measure();                          /* synchronous: vars are set before the first frame is painted */
      if(btn) btn.hidden=false;
      apply();
    }
    function stop(){
      live=false;
      root.classList.remove('dd-sq2--live','dd-sq2--paused','dd-sqm--paused');
      root.style.removeProperty('--sq2-dist'); root.style.removeProperty('--sq2-dur');
      if(btn) btn.hidden=true;
    }
    function sync(){ if(rm&&rm.matches) stop(); else start(); }

    /* pause reasons */
    if(fine){
      view.addEventListener('mouseenter',function(){ if(fine.matches){ why.hover=1; apply(); } });
      view.addEventListener('mouseleave',function(){ why.hover=0; apply(); });
    }
    view.addEventListener('focusin',function(){
      var kb=true; try{ kb=view.matches(':focus-visible'); }catch(e){}
      why.focus=kb?1:0; apply();
    });
    view.addEventListener('focusout',function(){ why.focus=0; apply(); });
    view.addEventListener('touchstart',function(){ why.touch=1; moved=false; lastTouch=Date.now(); apply(); },{passive:true});
    view.addEventListener('touchmove',function(){ moved=true; },{passive:true});
    function tEnd(){ why.touch=0; lastTouch=Date.now(); apply(); }
    view.addEventListener('touchend',tEnd,{passive:true});
    view.addEventListener('touchcancel',function(){ moved=true; tEnd(); },{passive:true});
    view.addEventListener('click',function(){
      /* a tap (touch → synthesized click) toggles the user pause; mouse clicks do nothing (hover already pauses) */
      if(live&&!moved&&Date.now()-lastTouch<800){ why.user=why.user?0:1; apply(); }
    });
    document.addEventListener('visibilitychange',function(){ why.hid=document.hidden?1:0; apply(); });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){ why.off=e.isIntersecting?0:1; }); apply();
      },{threshold:0}).observe(view);
    }
    if(btn) btn.addEventListener('click',function(){ why.user=why.user?0:1; apply(); });

    /* keep the loop exact when the card width changes at a breakpoint */
    var rt=0;
    window.addEventListener('resize',function(){ if(!live) return; clearTimeout(rt); rt=setTimeout(measure,150); });
    if(rm){ if(rm.addEventListener) rm.addEventListener('change',sync); else if(rm.addListener) rm.addListener(sync); }

    sync();
    return {
      state:function(){ return {live:live,paused:paused(),why:why,dist:dist,dur:root.style.getPropertyValue('--sq2-dur')}; },
      toggle:function(){ why.user=why.user?0:1; apply(); return why.user; }
    };
  }

  var api=null;
  roots.forEach(function(r){ var a=init(r); if(a&&!api) api=a; });
  if(api) window.__ddSq2=api;
}catch(err){}
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"15-squad-js":"86dba033e7"});

/* ---- 20-loadout.js ---- */
/* 20-loadout.js — [04] // Loadout, round 2: "perk orbit" (R2-2). Prefix: dd-lo-
   Seven perk nodes (desktop) / badges (mobile) + chips (mobile) all drive ONE readout (the seven .dd-lo-panel articles).
   - one active perk; auto-cycles every 3.5 s while the section is on screen; hover / focus / click selects and pauses, resumes 8 s after
     the last interaction; a small toggle in the stage corner pauses the tour for good (until pressed again)
   - first time the stage is on screen the nodes fly out of the pouch (80 ms stagger), then the cycle starts at perk 01
   - connector lines are measured here (px) so they always meet the real node + pouch boxes
   - reduced motion: no spawn, no cycle, no rotation (CSS), the user selects
   - first user selection publishes dd_loadout_open {perk} once
   Without this script the page still shows all seven perks as a plain list (see the CSS). */
(function(){
  try{
    var root=document.querySelector('[data-dd-lo]'); if(!root || root.getAttribute('data-lo-ready')) return;
    var stage=root.querySelector('[data-lo-stage]');
    var readout=root.querySelector('[data-lo-readout]');
    var panels=[].slice.call(root.querySelectorAll('.dd-lo-panel'));
    var N=panels.length; if(!stage || !readout || !N) return;
    root.setAttribute('data-lo-ready','1');
    root.classList.add('dd-lo-js');

    var nodes=[].slice.call(root.querySelectorAll('.dd-lo-node'));
    var chips=[].slice.call(root.querySelectorAll('.dd-lo-chip[data-i]'));
    var cells=[].slice.call(root.querySelectorAll('.dd-lo-nd'));
    var groups=[].slice.call(root.querySelectorAll('.dd-lo-lg'));
    var svg=root.querySelector('.dd-lo-lines');
    var pouch=root.querySelector('.dd-lo-pouch');
    var auto=root.querySelector('.dd-lo-auto');

    var mq=function(q){ return window.matchMedia ? window.matchMedia(q) : {matches:false}; };
    var mReduce=mq('(prefers-reduced-motion: reduce)');
    var mWide=mq('(min-width: 1000px)');
    var reduced=function(){ return !!mReduce.matches; };
    var wide=function(){ return !!mWide.matches; };

    var CYCLE=3500, RESUME=8000;
    var cur=0, sent=false, spawned=false, live=false, onScreen=false, hovering=false, userPaused=false;
    var nextAt=0, tm=0, holdT=0, hoverT=0, liveT=0;

    function pub(name){
      try{ if(window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('dd_loadout_open',{perk:name}); }catch(e){}
    }
    function perkName(i){
      var h=panels[i] && panels[i].querySelector('.dd-lo-pt'); return h ? h.textContent.replace(/\s+/g,' ').trim() : '';
    }

    /* ---------- paint the active perk everywhere ---------- */
    function applyMode(){
      /* roving tab stop on whichever control set is showing; the hidden-from-view set is taken out of the tab order + a11y tree
         (on mobile the orbit badges duplicate the chips, so they are aria-hidden there) */
      var w=wide();
      nodes.forEach(function(b,k){
        b.setAttribute('tabindex', w ? (k===cur?'0':'-1') : '-1');
        if(w) b.removeAttribute('aria-hidden'); else b.setAttribute('aria-hidden','true');
      });
      chips.forEach(function(b,k){ b.setAttribute('tabindex', !w ? (k===cur?'0':'-1') : '-1'); });
    }
    function paint(){
      panels.forEach(function(p,k){ p.classList.toggle('is-on',k===cur); });
      nodes.concat(chips).forEach(function(b){
        var on=(+b.getAttribute('data-i'))===cur;
        b.classList.toggle('is-on',on); b.setAttribute('aria-pressed',on?'true':'false');
      });
      cells.forEach(function(c,k){ c.classList.toggle('is-on',k===cur); });
      groups.forEach(function(g,k){ g.classList.toggle('is-on',k===cur); });
      applyMode();
    }
    function select(i,user){
      i=((i%N)+N)%N;
      if(user){
        var first=!sent;
        if(first){
          sent=true; pub(perkName(i));
          /* the readout only becomes a live region once the person has interacted (never during the auto tour);
             set it a beat before the change so the first update is announced too */
          readout.setAttribute('aria-live','polite'); readout.setAttribute('aria-atomic','true');
        }
        interact();
        if(i===cur) return;
        cur=i;
        if(first) setTimeout(paint,40); else paint();
        return;
      }
      if(i===cur) return;
      cur=i; paint();
    }

    /* ---------- auto tour ---------- */
    function canRun(){ return live && onScreen && !document.hidden && !userPaused && !reduced(); }
    function schedule(){
      clearTimeout(tm);
      if(!canRun()) return;
      tm=setTimeout(tick,Math.max(30,nextAt-Date.now()));
    }
    function tick(){
      if(!canRun()) return;
      /* the 8 s hold after a tap/click is also honoured here (dd-lo-hold is on for exactly that time) */
      if(hovering || Date.now()<nextAt || root.classList.contains('dd-lo-hold')){ tm=setTimeout(tick,hovering?400:Math.max(60,nextAt-Date.now())); return; }
      select(cur+1,false);
      nextAt=Date.now()+CYCLE; schedule();
    }
    function interact(){
      nextAt=Date.now()+RESUME; schedule();
      /* mobile: stop the ring turning under a thumb while the person is picking */
      root.classList.add('dd-lo-hold'); clearTimeout(holdT);
      holdT=setTimeout(function(){ root.classList.remove('dd-lo-hold'); },RESUME);
    }
    function setPaused(p){
      userPaused=p;
      if(auto){ auto.classList.toggle('is-paused',p); auto.setAttribute('aria-label',p?'Resume the automatic perk tour':'Pause the automatic perk tour'); }
      if(p) clearTimeout(tm); else { nextAt=Date.now()+CYCLE; schedule(); }
    }
    if(auto){
      if(!reduced()) auto.hidden=false;
      auto.addEventListener('click',function(){ setPaused(!userPaused); });
    }

    /* ---------- geometry: connector lines, spawn offsets ---------- */
    var rafL=0;
    function layout(){
      cancelAnimationFrame(rafL);
      rafL=requestAnimationFrame(function(){
        try{
          if(!wide() || !svg || !pouch) return;
          var sw=stage.clientWidth, sh=stage.clientHeight; if(!sw||!sh) return;
          svg.setAttribute('viewBox','0 0 '+sw+' '+sh);
          var px=pouch.offsetLeft, py=pouch.offsetTop, hw=pouch.offsetWidth/2+22, hh=pouch.offsetHeight/2+22;
          cells.forEach(function(c,k){
            var nx=c.offsetLeft, ny=c.offsetTop, nw=c.offsetWidth/2, nh=c.offsetHeight/2;
            c.style.setProperty('--fx',(px-nx)+'px'); c.style.setProperty('--fy',(py-ny)+'px');
            var g=groups[k]; if(!g) return;
            var ln=g.querySelector('line'), pt=g.querySelector('circle');
            var dx=px-nx, dy=py-ny; if(!dx && !dy) return;
            var adx=Math.abs(dx)||1e-6, ady=Math.abs(dy)||1e-6;
            var tN=Math.min(nw/adx,nh/ady);     /* where the ray leaves the node box   */
            var tP=Math.min(hw/adx,hh/ady);     /* where it meets the (padded) pouch box */
            var sx=nx+dx*tN, sy=ny+dy*tN, ex=px-dx*tP, ey=py-dy*tP;
            var ok=(tN+tP)<1;
            g.style.display=ok?'':'none';
            /* drawn pouch -> node so the dash flow runs outward */
            ln.setAttribute('x1',ex.toFixed(1)); ln.setAttribute('y1',ey.toFixed(1));
            ln.setAttribute('x2',sx.toFixed(1)); ln.setAttribute('y2',sy.toFixed(1));
            pt.setAttribute('cx',ex.toFixed(1)); pt.setAttribute('cy',ey.toFixed(1));
          });
        }catch(e){}
      });
    }
    if(window.ResizeObserver){
      var ro=new ResizeObserver(layout); ro.observe(stage); cells.forEach(function(c){ ro.observe(c); });
    }
    window.addEventListener('resize',layout);
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    window.addEventListener('load',layout);

    /* ---------- spawn (once) ---------- */
    function startLive(){
      /* R4-Y: never pull a later resume time back to the 3.5 s cycle. A tap during the 1 s spawn used to be overwritten here
         (interact() had set nextAt = tap + 8 s, then spawn ended and reset it to now + 3.5 s), so on touch the perk was replaced ~3 s after the tap. */
      live=true; nextAt=Math.max(nextAt,Date.now()+CYCLE); schedule();
    }
    function spawn(){
      if(spawned) return; spawned=true;
      layout();
      if(reduced() || !root.classList.contains('dd-lo-pre')){ root.classList.remove('dd-lo-pre'); startLive(); return; }
      root.classList.add('dd-lo-spawn'); root.classList.remove('dd-lo-pre');
      liveT=setTimeout(function(){ root.classList.remove('dd-lo-spawn'); startLive(); },1000);
    }
    var hasIO='IntersectionObserver' in window;
    if(hasIO && !reduced()) root.classList.add('dd-lo-pre');

    /* ---------- controls ---------- */
    function group(el){ return el.classList.contains('dd-lo-chip') ? chips : nodes; }
    function moveFocus(btn,to){
      var set=group(btn); to=((to%N)+N)%N;
      select(to,true); applyMode();
      if(set[to]) set[to].focus();
    }
    nodes.concat(chips).forEach(function(b){
      var i=+b.getAttribute('data-i');
      b.addEventListener('click',function(){ select(i,true); });
      b.addEventListener('focus',function(){ select(i,true); });
      b.addEventListener('keydown',function(e){
        var k=e.key, chip=b.classList.contains('dd-lo-chip'), d=0;
        if(k==='ArrowRight') d=1; else if(k==='ArrowLeft') d=-1;
        else if(k==='ArrowDown') d=chip?2:1; else if(k==='ArrowUp') d=chip?-2:-1;
        else if(k==='Home'){ e.preventDefault(); moveFocus(b,0); return; }
        else if(k==='End'){ e.preventDefault(); moveFocus(b,N-1); return; }
        else return;
        e.preventDefault();
        var to=i+d;
        if(chip && (to<0||to>=N)) to=Math.max(0,Math.min(N-1,to));
        moveFocus(b,to);
      });
    });
    /* hover selects (mouse / pen only; a short dwell so sweeping across the stage doesn't flicker) */
    nodes.forEach(function(b){
      var i=+b.getAttribute('data-i');
      b.addEventListener('pointerenter',function(e){
        if(e.pointerType==='touch') return;
        hovering=true; clearTimeout(hoverT);
        hoverT=setTimeout(function(){ select(i,true); },60);
      });
      b.addEventListener('pointerleave',function(e){
        if(e.pointerType==='touch') return;
        clearTimeout(hoverT); hovering=false; interact();
      });
    });
    if(readout){
      readout.addEventListener('pointerenter',function(e){ if(e.pointerType!=='touch'){ hovering=true; } });
      readout.addEventListener('pointerleave',function(e){ if(e.pointerType!=='touch'){ hovering=false; interact(); } });
    }

    /* ---------- visibility: spawn once, pause everything when off screen ---------- */
    if(hasIO){
      var oSpawn=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ oSpawn.disconnect(); spawn(); } });
      },{threshold:.35});
      oSpawn.observe(stage);
      var oSeen=new IntersectionObserver(function(es){
        es.forEach(function(e){
          onScreen=e.isIntersecting;
          root.classList.toggle('dd-lo-off',!onScreen);
          if(onScreen){ if(live) nextAt=Math.max(nextAt,Date.now()+1500); schedule(); } else clearTimeout(tm);
        });
      },{threshold:0});
      oSeen.observe(root);
    }else{
      onScreen=true; spawn();
    }
    document.addEventListener('visibilitychange',function(){ if(document.hidden) clearTimeout(tm); else { nextAt=Math.max(nextAt,Date.now()+1500); schedule(); } });
    function onMode(){ applyMode(); layout(); }
    function listen(m,f){ if(m.addEventListener) m.addEventListener('change',f); else if(m.addListener) m.addListener(f); }
    listen(mWide,onMode);
    listen(mReduce,function(){
      if(reduced()){ root.classList.remove('dd-lo-pre','dd-lo-spawn'); clearTimeout(tm); if(auto) auto.hidden=true; }
      else if(auto) auto.hidden=false;
    });

    paint(); layout();
  }catch(e){}
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"20-loadout-js":"3024dc9da8"});

/* ---- 30-order.js ---- */
/* ============================================================
   30-order.js — workstream C (13 Oct 2026); round 2 (15 Oct 2026)
   1. Order section showcase: the slow dashed ring behind the gallery only runs while the frame is on screen.
      (Gallery switching is the existing [data-gal] handler in respawn-shopify.js; the plan colour / CTA ring
      are driven by sync() in respawn.js; the spec sheet and the patch notes rows are native <details>.)
   2. Lightbox: full-screen viewer used by the gallery's Zoom button ([data-zoom-open] inside [data-gal]) and by the
      patch notes "Open the label" button. Arrows, swipe, Esc, close button, focus trap + return, scroll lock.
   3. Patch notes label inspector (.dd-pn): zooms the back-of-pouch image to the label region of the open row.
      (R4-X, 16 Oct 2026) At <= 600px the hotspot dots are hidden (CSS) and the idle chip reads "Tap a row to scan".
   5. (v10 X3b, 18 Oct 2026) window.ddDispatch: the real dispatch cut-off (2pm, working days, Europe/London) -> live delivery line
      above the CTA ([data-dd-dc="buy"]) and the shared logic the cart (60-pdp-cart.js) reuses.
   4. (R4-X) Buy panel: the trust row's middle item reads "Cancel anytime" only while Death Squad is selected, otherwise
      "No subscription"; and ?plan=solo|sub|stack in the URL preselects that plan (home + product page).
   ============================================================ */
(function(){
"use strict";
var doc=document, root=doc.documentElement;
var RM=false;
try{ RM=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches); }catch(e){}
try{ root.classList.add('dd-ob-js'); }catch(e){}

/* ---------- 1. showcase ring: only while on screen ---------- */
try{
  var shows=[].slice.call(doc.querySelectorAll('.dd-ob-show'));
  if(shows.length){
    if(!('IntersectionObserver' in window)){ shows.forEach(function(s){ s.classList.add('dd-ob-live'); }); }
    else{
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){ e.target.classList.toggle('dd-ob-live',e.isIntersecting); });
      },{rootMargin:'80px 0px'});
      shows.forEach(function(s){ io.observe(s); });
    }
  }
}catch(err){}

/* ---------- 2. lightbox ---------- */
var LB=null;
var ICON_X='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
var ICON_L='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 4l-8 8 8 8"/></svg>';
var ICON_R='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 4l8 8-8 8"/></svg>';

function lbBuild(){
  var el=doc.createElement('div');
  el.className='dd-ob-lb'; el.hidden=true;
  el.setAttribute('role','dialog'); el.setAttribute('aria-modal','true'); el.setAttribute('aria-label','Product images');
  el.innerHTML=
    '<div class="dd-ob-lb__bar"><span class="dd-ob-lb__count" aria-hidden="true"></span>'+
      '<button type="button" class="dd-ob-lb__x" aria-label="Close">'+ICON_X+'</button></div>'+
    '<button type="button" class="dd-ob-lb__nav dd-ob-lb__nav--prev" aria-label="Previous image">'+ICON_L+'</button>'+
    '<div class="dd-ob-lb__stage"><img class="dd-ob-lb__img" alt="" decoding="async" draggable="false"></div>'+
    '<button type="button" class="dd-ob-lb__nav dd-ob-lb__nav--next" aria-label="Next image">'+ICON_R+'</button>'+
    '<p class="dd-ob-lb__cap" aria-live="polite"></p>';
  doc.body.appendChild(el);
  LB={el:el, count:el.querySelector('.dd-ob-lb__count'), x:el.querySelector('.dd-ob-lb__x'),
      prev:el.querySelector('.dd-ob-lb__nav--prev'), next:el.querySelector('.dd-ob-lb__nav--next'),
      stage:el.querySelector('.dd-ob-lb__stage'), img:el.querySelector('.dd-ob-lb__img'), cap:el.querySelector('.dd-ob-lb__cap'),
      items:[], i:0, opener:null, onClose:null, isOpen:false};
  LB.x.addEventListener('click',lbClose);
  LB.prev.addEventListener('click',function(){ lbGo(-1); });
  LB.next.addEventListener('click',function(){ lbGo(1); });
  el.addEventListener('click',function(e){ if(e.target===el||e.target===LB.stage) lbClose(); });
  var sx=0, sy=0, tracking=false;
  LB.stage.addEventListener('touchstart',function(e){
    if(e.touches.length!==1){ tracking=false; return; }
    tracking=true; sx=e.touches[0].clientX; sy=e.touches[0].clientY;
  },{passive:true});
  LB.stage.addEventListener('touchend',function(e){
    if(!tracking) return; tracking=false;
    var t=e.changedTouches[0], dx=t.clientX-sx, dy=t.clientY-sy;
    if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.4) lbGo(dx<0?1:-1);
  },{passive:true});
  LB.stage.addEventListener('touchcancel',function(){ tracking=false; },{passive:true});
}
function lbShow(i,first){
  var n=LB.items.length; if(!n) return;
  LB.i=((i%n)+n)%n;
  var it=LB.items[LB.i];
  LB.img.alt=it.alt||'';
  if(!RM){ LB.img.style.animation='none'; void LB.img.offsetWidth; LB.img.style.animation=''; }
  LB.img.src=it.src;
  if(it.w&&it.h){ LB.img.width=it.w; LB.img.height=it.h; } else { LB.img.removeAttribute('width'); LB.img.removeAttribute('height'); }
  LB.count.textContent=n>1?(LB.i+1)+' / '+n:'';
  LB.cap.innerHTML='';
  var sr=doc.createElement('span'); sr.className='dd-ob-sr'; sr.textContent=n>1?'Image '+(LB.i+1)+' of '+n+': ':'';
  LB.cap.appendChild(sr); LB.cap.appendChild(doc.createTextNode(it.cap||it.alt||''));
  LB.prev.hidden=LB.next.hidden=(n<2);
  if(n>1){ [LB.i-1,LB.i+1].forEach(function(k){ var o=LB.items[((k%n)+n)%n]; if(o&&o.src){ var im=new Image(); im.src=o.src; } }); }
}
function lbGo(d){ if(LB&&LB.isOpen&&LB.items.length>1) lbShow(LB.i+d); }
function lbFocusables(){
  return [LB.x,LB.prev,LB.next].filter(function(b){ return !b.hidden; });
}
function lbKey(e){
  if(!LB||!LB.isOpen) return;
  var k=e.key;
  if(k==='Escape'||k==='Esc'){ e.preventDefault(); e.stopPropagation(); lbClose(); }
  else if(k==='ArrowLeft'){ e.preventDefault(); e.stopPropagation(); lbGo(-1); }
  else if(k==='ArrowRight'){ e.preventDefault(); e.stopPropagation(); lbGo(1); }
  else if(k==='Tab'){
    var f=lbFocusables(), a=doc.activeElement, ix=f.indexOf(a);
    if(!f.length){ e.preventDefault(); return; }
    if(e.shiftKey){ if(ix<=0){ e.preventDefault(); f[f.length-1].focus(); } }
    else if(ix===-1||ix===f.length-1){ e.preventDefault(); f[0].focus(); }
  }
}
function lbOpen(items,start,opener,onClose){
  try{
    if(!items||!items.length) return;
    if(!LB) lbBuild();
    LB.items=items; LB.opener=opener||doc.activeElement; LB.onClose=onClose||null;
    LB.el.hidden=false; LB.isOpen=true;
    root.classList.add('dd-ob-lock');
    lbShow(start||0,true);
    doc.addEventListener('keydown',lbKey,true);
    LB.x.focus();
  }catch(err){}
}
function lbClose(){
  try{
    if(!LB||!LB.isOpen) return;
    LB.isOpen=false; LB.el.hidden=true; LB.img.removeAttribute('src');
    root.classList.remove('dd-ob-lock');
    doc.removeEventListener('keydown',lbKey,true);
    var cb=LB.onClose, i=LB.i, op=LB.opener; LB.onClose=null;
    if(cb){ try{ cb(i); }catch(e){} }
    if(op&&op.focus&&doc.contains(op)) op.focus();
  }catch(err){}
}

/* keep the active thumbnail in view inside the (possibly scrolling) single row */
function thumbIntoView(g){
  try{
    var row=g.querySelector('.dd-gal__thumbs'), on=g.querySelector('.dd-gal__thumb[aria-selected="true"]');
    if(!row||!on||row.scrollWidth<=row.clientWidth+1) return;
    var x=on.offsetLeft-(row.clientWidth-on.offsetWidth)/2;
    row.scrollTo?row.scrollTo({left:x,behavior:RM?'auto':'smooth'}):(row.scrollLeft=x);
  }catch(e){}
}

/* gallery zoom */
try{
  [].forEach.call(doc.querySelectorAll('[data-gal]'),function(g){
    var btn=g.querySelector('[data-zoom-open]');
    var thumbs=g.querySelector('.dd-gal__thumbs');
    if(thumbs) thumbs.addEventListener('click',function(){ setTimeout(function(){ thumbIntoView(g); },0); });
    if(thumbs) thumbs.addEventListener('keyup',function(e){ if(e.key==='ArrowLeft'||e.key==='ArrowRight') thumbIntoView(g); });
    if(!btn) return;
    btn.addEventListener('click',function(){
      var imgs=[].slice.call(g.querySelectorAll('.dd-gal__img[data-zoom]')), cur=0, items=[];
      imgs.forEach(function(im,k){
        if(!im.hidden) cur=k;
        items.push({src:im.getAttribute('data-zoom'),alt:im.getAttribute('alt')||'',w:parseInt(im.getAttribute('data-zw'),10)||0,h:parseInt(im.getAttribute('data-zh'),10)||0,idx:im.getAttribute('data-i')});
      });
      lbOpen(items,cur,btn,function(i){
        var it=items[i]; if(!it) return;
        var th=g.querySelector('.dd-gal__thumb[data-i="'+it.idx+'"]');
        if(th&&th.getAttribute('aria-selected')!=='true') th.click();
        thumbIntoView(g);
      });
    });
  });
}catch(err){}

/* ---------- 3. patch notes: label inspector ---------- */
try{
  var sec=doc.querySelector('.dd-pn');
  var panel=sec&&sec.querySelector('.dd-pn-insp__panel');
  if(sec&&panel){
    var grid=sec.querySelector('.dd-pn__grid');
    var view=panel.querySelector('.dd-pn-insp__view'), stage=panel.querySelector('.dd-pn-insp__stage');
    var box=panel.querySelector('.dd-pn-insp__scanbox'), img=panel.querySelector('.dd-pn-insp__img');
    var chipK=panel.querySelector('.dd-pn-insp__chipk'), chipV=panel.querySelector('.dd-pn-insp__chipv');
    var stEl=panel.querySelector('.dd-pn-insp__st');
    var rows=[].slice.call(sec.querySelectorAll('.dd-pn__row'));
    /* label regions: percent of the 829x1400 back-of-pouch image (x, y, width, height) of the UNROTATED box, plus r =
       its rotation in degrees (clockwise, about the box centre). The printed label sits about 1.8deg off level (the
       value column drops ~12px against the labels in the 1400px render), so r follows the text. Values were fitted to
       the measured ink of each text block in respawn-studio-02-1400.webp (outer edge of the frame = ink + 3-5px) and
       checked on screen at 1440 and 390. name = caption chip text. */
    var REG={
      nutrition:{x:14.58,y:36.89,w:62.77,h:15.05,r:1.8, name:'Nutrition table'},
      magnesium:{x:15.11,y:41.18,w:62.05,h:4.32, r:1.5, name:'Magnesium'},
      glycinate:{x:15.55,y:42.19,w:21.26,h:1.43, r:1.6, name:'Magnesium glycinate'},
      pepper:   {x:15.13,y:45.27,w:61.02,h:2.72, r:1.8, name:'Black pepper extract'},
      ingredients:{x:15.15,y:52.10,w:57.24,h:3.01,r:1.1,name:'Ingredients'},
      use:      {x:77.67,y:48.09,w:12.08,h:11.72,r:-4,  name:'Suggested use'},
      uk:       {x:83.23,y:27.64,w:7.60, h:7.07, r:0,   name:'Made in the UK'}
    };
    var order=[], cur=null, lastKey=null;
    sec.classList.add('dd-pn-js');
    /* idle chip text: the dots exist from 601px up; below that the rows are the way in */
    var mqDots=window.matchMedia?window.matchMedia('(max-width:600px)'):null;
    function idleText(){ return (mqDots&&mqDots.matches)?'Tap a row to scan':'Tap a dot to scan'; }

    /* inspector height = the CLOSED list height, whatever is open (sum of the summaries + their 1px rules) */
    function setH(){
      if(!grid) return;
      var h=1; rows.forEach(function(r){ var s=r.querySelector('summary'); if(s) h+=s.offsetHeight+1; });
      grid.style.setProperty('--pn-h',h+'px');
    }
    function apply(instant){
      var key=cur?cur.getAttribute('data-region'):null, reg=key&&REG[key]?REG[key]:null;
      var VW=view.clientWidth, VH=view.clientHeight, SW=stage.offsetWidth, SH=stage.offsetHeight;
      if(!VW||!SW) return;
      var tx=0, ty=0, s=1;
      if(reg){
        var cx=(reg.x+reg.w/2)/100*SW-SW/2, cy=(reg.y+reg.h/2)/100*SH-SH/2;
        var rw=reg.w/100*SW, rh=reg.h/100*SH;
        var sMax=Math.min(6,1.12*1400/SH);               /* never magnify past ~1.1x the 1400px source */
        s=Math.max(1.5,Math.min(VW*0.8/rw,VH*0.46/rh,sMax));
        tx=-s*cx; ty=-VH*0.06-s*cy;
      }
      var jump=!!(instant||RM);
      if(jump){ stage.style.transition='none'; box.style.transition='none'; }
      else if(reg&&lastKey===null){ box.style.transitionProperty='opacity'; }   /* first lock: the box appears in place, it doesn't fly in from the corner */
      if(reg){
        box.style.setProperty('--bx',reg.x+'%'); box.style.setProperty('--by',reg.y+'%');
        box.style.setProperty('--bw',reg.w+'%'); box.style.setProperty('--bh',reg.h+'%');
        box.style.setProperty('--br',(reg.r||0)+'deg');
        chipV.textContent=reg.name;
      }else{
        chipV.textContent=idleText();
      }
      stage.style.setProperty('--inv',(1/s).toFixed(4));
      stage.style.transform='translate('+tx.toFixed(1)+'px,'+ty.toFixed(1)+'px) scale('+s.toFixed(3)+')';
      panel.setAttribute('data-state',reg?'lock':'idle');
      if(stEl) stEl.textContent=reg?'Target locked':'Scan ready';
      var wasIdle=(lastKey===null);
      lastKey=reg?key:null;
      if(jump||(reg&&wasIdle)){
        void stage.offsetWidth;
        requestAnimationFrame(function(){ stage.style.transition=''; box.style.transition=''; box.style.transitionProperty=''; });
      }
    }
    function sync(){
      cur=order.length?order[order.length-1]:null;
      apply(false);
    }
    rows.forEach(function(r){
      if(r.open) order.push(r);
      r.addEventListener('toggle',function(){
        var i=order.indexOf(r); if(i>-1) order.splice(i,1);
        if(r.open) order.push(r);
        sync();
      });
    });
    [].forEach.call(panel.querySelectorAll('.dd-pn-hot'),function(h){
      h.addEventListener('click',function(){
        var r=rows[parseInt(h.getAttribute('data-row'),10)]; if(!r) return;
        if(r.open){ var i=order.indexOf(r); if(i>-1) order.splice(i,1); order.push(r); sync(); }
        else r.open=true;                                   /* the toggle event does the rest */
      });
    });
    var openBtn=sec.querySelector('[data-pn-open]');
    if(openBtn&&img) openBtn.addEventListener('click',function(){
      lbOpen([{src:img.getAttribute('data-zoom')||img.currentSrc||img.src,alt:img.getAttribute('alt')||'',cap:'The label. Unedited.',w:829,h:1400}],0,openBtn);
    });

    setH(); sync();
    if(mqDots){
      var onMq=function(){ if(!cur&&chipV) chipV.textContent=idleText(); };
      if(mqDots.addEventListener) mqDots.addEventListener('change',onMq); else if(mqDots.addListener) mqDots.addListener(onMq);
    }
    var tick=0;
    function relayout(){ if(tick) return; tick=requestAnimationFrame(function(){ tick=0; setH(); apply(true); }); }
    if('ResizeObserver' in window){ var ro=new ResizeObserver(relayout); ro.observe(view); }   /* the view only: the list growing must not interrupt a zoom */
    else window.addEventListener('resize',relayout);
    window.addEventListener('load',relayout);
    if(doc.fonts&&doc.fonts.ready) doc.fonts.ready.then(relayout);

    /* pulses and the sweep only run while the section is on screen */
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){ sec.classList.toggle('dd-pn-live',e.isIntersecting); }); },{rootMargin:'60px 0px'}).observe(sec);
    }else sec.classList.add('dd-pn-live');
  }
}catch(err){}

/* ---------- 4. buy panel: trust row follows the plan; ?plan= preselects it ---------- */
try{
  function trustSync(radio){
    try{
      var sub=!!radio&&radio.value==='sub';
      [].forEach.call(doc.querySelectorAll('[data-trust-sub]'),function(el){
        el.setAttribute('data-sub',sub?'1':'0');
        var t=el.querySelector('[data-trust-sub-t]'); if(t) t.textContent=sub?'Cancel anytime':'No subscription';
      });
    }catch(e){}
  }
  doc.addEventListener('change',function(e){
    try{ var t=e.target; if(t&&t.name==='plan'&&t.type==='radio'&&t.checked) trustSync(t); }catch(err){}
  });
  /* ?plan=solo|sub|stack (footer links, shared links): check that radio and fire a bubbling change so respawn.js sync()
     updates the total, note, ring and CTA exactly as a tap would. Only if that radio exists on this page. */
  var want=null;
  try{ want=new URLSearchParams(window.location.search).get('plan'); }catch(e){}
  if(want==='solo'||want==='sub'||want==='stack'){
    var wr=doc.querySelector('input[name="plan"][value="'+want+'"]');
    if(wr&&!wr.checked){
      wr.checked=true;
      wr.dispatchEvent(new Event('change',{bubbles:true}));
    }
  }
  trustSync(doc.querySelector('input[name="plan"]:checked'));
}catch(err){}

/* ---------- 5. dispatch countdown (v10 X3b) ----------
   Facts (store shipping policy, 17 Oct 2026): UK only, free, 48-hour tracked. Orders before 2pm on a working day are dispatched
   the same day; later orders, weekends and bank holidays go out the next working day. Most orders arrive within two working
   days of dispatch. Everything is computed in Europe/London wall-clock time, whatever the visitor's own timezone.
   No-JS / failure: the server-rendered line stays as it is. Updates every 30s (no seconds shown), paused while the tab is hidden.
   Test clock: ?ddnow=2026-10-19T12:10:00Z overrides "now", but only in the theme editor or on a ?preview_theme_id= preview. */
try{
  /* England & Wales bank holidays. EXTEND THIS LIST EVERY YEAR (after the last date a weekday is treated as a working day). */
  var BH={'2026-12-25':1,'2026-12-28':1,'2027-01-01':1,'2027-03-26':1,'2027-03-29':1,'2027-05-03':1,'2027-05-31':1,'2027-08-30':1,'2027-12-27':1,'2027-12-28':1};
  var DAYS=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONS=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var CUT=14*3600, OFF=0, fmt=null;
  try{
    var q=new URLSearchParams(window.location.search).get('ddnow');
    var okTest=(window.Shopify&&window.Shopify.designMode)||/[?&]preview_theme_id=/.test(window.location.search);
    if(q&&okTest){ var t=Date.parse(q); if(isFinite(t)) OFF=t-Date.now(); }
  }catch(e){}
  function p2(n){ return n<10?'0'+n:''+n; }
  function london(ms){
    if(!fmt) fmt=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',minute:'numeric',second:'numeric',hourCycle:'h23'});
    var o={}; fmt.formatToParts(new Date(ms)).forEach(function(x){ o[x.type]=parseInt(x.value,10); });
    return {y:o.year,m:o.month,d:o.day,s:(o.hour%24)*3600+o.minute*60+o.second};
  }
  function dn(y,m,d){ return Math.round(Date.UTC(y,m-1,d)/864e5); }       /* day number (days since 1970-01-01) */
  function ymd(n){ var x=new Date(n*864e5); return {y:x.getUTCFullYear(),m:x.getUTCMonth()+1,d:x.getUTCDate(),w:x.getUTCDay()}; }
  function isWork(n){ var x=ymd(n); return x.w>0&&x.w<6&&!BH[x.y+'-'+p2(x.m)+'-'+p2(x.d)]; }
  function addWork(n,k){ while(k>0){ n++; if(isWork(n)) k--; } return n; }
  function short(n){ var x=ymd(n); return DAYS[x.w].slice(0,3)+' '+x.d; }
  function range(a,b){
    var x=ymd(a), y=ymd(b);
    return short(a)+(x.m!==y.m?' '+MONS[x.m-1]:'')+' – '+short(b)+' '+MONS[y.m-1];
  }
  function left(mins){ var h=Math.floor(mins/60), m=mins%60; return h?(m?h+'h '+m+'m':h+'h'):m+'m'; }
  /* -> {today:bool, mins, left:'2h 14m', word:'today'|'tomorrow'|'Monday'|'Tue 3 Nov', arrival:'Tue 20 – Wed 21 Oct'} or null */
  function info(ms){
    try{
      var p=london(ms==null?Date.now()+OFF:ms), t=dn(p.y,p.m,p.d), same=isWork(t)&&p.s<CUT;
      var disp=same?t:addWork(t,1), diff=disp-t, word;
      if(diff===0) word='today'; else if(diff===1) word='tomorrow';
      else if(diff<=6) word=DAYS[ymd(disp).w];
      else { var x=ymd(disp); word=short(disp)+' '+MONS[x.m-1]; }
      var mins=same?Math.ceil((CUT-p.s)/60):0;
      return {today:same,mins:mins,left:same?left(mins):'',word:word,arrival:range(addWork(disp,1),addWork(disp,2))};
    }catch(e){ return null; }
  }
  window.ddDispatch={info:info,now:function(){ return Date.now()+OFF; }};

  /* drive every [data-dd-dc="buy"] line */
  function paintBuy(el){
    var i=info(); if(!i) return;
    var txt=i.today?'Free UK delivery · order within '+i.left+' — dispatched today.':'Free UK delivery · order now — dispatched '+i.word+'.';
    if(el.getAttribute('data-dd-k')===txt) return;
    el.setAttribute('data-dd-k',txt);
    el.textContent='';
    if(i.today){ var dot=doc.createElement('i'); dot.className='dd-dc-dot'; dot.setAttribute('aria-hidden','true'); el.appendChild(dot); }
    el.appendChild(doc.createTextNode(txt));
  }
  var buyEls=[].slice.call(doc.querySelectorAll('[data-dd-dc="buy"]'));
  if(buyEls.length&&window.Intl&&Intl.DateTimeFormat){
    var timer=0;
    var run=function(){ buyEls.forEach(paintBuy); };
    var stop=function(){ if(timer){ clearInterval(timer); timer=0; } };
    var go=function(){ stop(); run(); timer=setInterval(run,30000); };
    if(doc.hidden) run(); else go();
    doc.addEventListener('visibilitychange',function(){ if(doc.hidden) stop(); else go(); });
    /* the pulse only runs while the line is on screen */
    if('IntersectionObserver' in window){
      var lio=new IntersectionObserver(function(es){ es.forEach(function(e){ e.target.classList.toggle('dd-dc-live',e.isIntersecting); }); },{rootMargin:'40px 0px'});
      buyEls.forEach(function(e){ lio.observe(e); });
    }else buyEls.forEach(function(e){ e.classList.add('dd-dc-live'); });
  }
}catch(err){}
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"30-order-js":"bc8c0b3e10"});

/* ---- 40-compare.js ---- */
/* [07] The tier list: one-round fight (workstream D). Sequence plays once when .dd-vs scrolls into view; Rematch replays it.
   Default markup/CSS is the FINAL state; this script arms the pre-fight state and runs one timeout chain. Decorative only. */
;(function(){
  'use strict';
  try{
    var mql=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
    function reduced(){ return !!(mql&&mql.matches); }

    var T_BANNER=1000,   // ROUND 1 / FIGHT! banner, ms
        T_STEP=450,      // one hit per stat row
        T_TRAVEL=230,    // streak flight time
        T_IMPACT=170,    // streak launch -> damage lands
        T_TAIL=540,      // last impact -> end state
        RIVAL_END=0.12,  // rival HP at the end
        HERO_END=0.92;   // RESPAWN HP at the end (after the counter-attack)

    function restart(el,cls){ el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
    function setHp(el,v){ el.style.setProperty('--ft-hp',String(v)); }

    function init(){
      var vs=document.querySelector('.dd-vs[data-dd-ft]');
      if(!vs||vs.__ddft) return;
      var root=vs.closest('.dd-cmp');
      var npc=vs.querySelector('.dd-fighter--npc'), hero=vs.querySelector('.dd-fighter--hero');
      if(!root||!npc||!hero) return;
      var rivalPack=npc.querySelector('.dd-bot'), heroPack=hero.querySelector('img.dd-bot'); /* v10: rival = inline SVG (or an uploaded img) */
      var rivalHp=npc.querySelector('.dd-hpb i'), heroHp=hero.querySelector('.dd-hpb i');
      var comboN=vs.querySelector('.dd-ft-combo .dd-ft-n'), rematch=vs.querySelector('.dd-ft-rematch');
      if(!rivalPack||!heroPack||!rivalHp||!heroHp) return;
      vs.__ddft=1;

      /* ---- the hits: one per table row, in table order ---- */
      var rows=[].slice.call(root.querySelectorAll('.dd-grid-tbl__row'));
      var hits=rows.map(function(r){
        var tag=r.querySelector('.dd-win');
        var kind=r.getAttribute('data-ft')||(tag?(tag.classList.contains('dd-win--alt')?'honest':'win'):'counter');
        var dmg=parseFloat(r.getAttribute('data-ft-dmg'))||(kind==='counter'?6:kind==='honest'?8:10);
        var lab=r.querySelector('.dd-cel--lab');
        var name=(r.getAttribute('data-ft-name')||(lab?lab.textContent:'')||'').replace(/\s+/g,' ').trim().toUpperCase();
        return {row:r,kind:kind,dmg:dmg,name:name,pt:null};
      });
      if(!hits.length) return;
      var wins=hits.filter(function(h){return h.kind==='win';}).length;
      if(comboN){
        comboN.textContent=String(wins);
        if(comboN.parentNode) comboN.parentNode.style.display=wins?'':'none';
      }
      /* HP: label numbers are hit values; the bars are scaled so the fight always ends rival 12% / RESPAWN 92% */
      var rTot=0,cTot=0,rHpNow=1,hHpNow=1;
      hits.forEach(function(h){ if(h.kind==='counter') cTot+=h.dmg; else rTot+=h.dmg; });
      hits.forEach(function(h){
        if(h.kind==='counter'){ hHpNow-=cTot?h.dmg/cTot*(1-HERO_END):0; h.hp=Math.max(0,Math.round(hHpNow*1000)/1000); }
        else{ rHpNow-=rTot?h.dmg/rTot*(1-RIVAL_END):0; h.hp=Math.max(0,Math.round(rHpNow*1000)/1000); }
      });

      /* ---- fight layer ---- */
      var streak=document.createElement('span'); streak.className='dd-ft-streak'; streak.setAttribute('aria-hidden','true');
      var spark=document.createElement('span'); spark.className='dd-ft-spark'; spark.setAttribute('aria-hidden','true');
      vs.appendChild(streak); vs.appendChild(spark);

      var timer=0, running=false, played=false, seq=0;

      function clearTimer(){ if(timer){ clearTimeout(timer); timer=0; } seq++; }
      function anim(el,frames,opts){ if(el.animate){ try{ return el.animate(frames,opts); }catch(e){} } return null; }
      function cancelFx(){
        [streak,spark].forEach(function(el){ try{ el.getAnimations&&el.getAnimations().forEach(function(a){a.cancel();}); }catch(e){} el.style.opacity='0'; });
        [].slice.call(vs.querySelectorAll('.dd-ft-dmg')).forEach(function(el){ el.parentNode&&el.parentNode.removeChild(el); });
        npc.classList.remove('dd-ft-hurt','dd-ft-hurt--lite'); hero.classList.remove('dd-ft-hurt','dd-ft-hurt--lite');
      }
      function arm(){
        clearTimer(); cancelFx();
        root.classList.add('dd-ft-armed'); root.classList.remove('dd-ft-end','dd-ft-bn');
        hits.forEach(function(h){ h.row.classList.remove('dd-ft-done','dd-ft-sw','dd-ft-sw--bad'); });
        setHp(rivalHp,1); setHp(heroHp,1);
      }
      function finalState(){ /* static end state, no motion */
        clearTimer(); cancelFx();
        root.classList.remove('dd-ft-armed','dd-ft-bn','dd-ft-end','dd-ft-js','dd-ft-live');
        hits.forEach(function(h){ h.row.classList.remove('dd-ft-sw','dd-ft-sw--bad'); h.row.classList.add('dd-ft-done'); });
        setHp(rivalHp,RIVAL_END); setHp(heroHp,HERO_END);
        running=false;
      }
      function end(){
        running=false;
        setHp(rivalHp,RIVAL_END); setHp(heroHp,HERO_END);
        hits.forEach(function(h){ h.row.classList.add('dd-ft-done'); });
        root.classList.remove('dd-ft-armed','dd-ft-bn');
        root.classList.add('dd-ft-end');
      }

      /* streak flight (coordinates from getBoundingClientRect at fire time, so any layout works) */
      function launch(h,i){
        var counter=h.kind==='counter';
        h.row.classList.toggle('dd-ft-sw--bad',counter);
        restart(h.row,'dd-ft-sw');
        var vr=vs.getBoundingClientRect(), hr=heroPack.getBoundingClientRect(), rr=rivalPack.getBoundingClientRect();
        var from=counter?rr:hr, to=counter?hr:rr;
        var jit=((i%3)-1)*Math.min(18,from.height*.1);
        var x0=(counter?from.right-from.width*.2:from.left+from.width*.2)-vr.left;
        var y0=from.top+from.height*.5+jit-vr.top;
        var x1=to.left+to.width*(counter?.42:.58)-vr.left;
        var y1=to.top+to.height*.5-jit*.5-vr.top;
        h.pt={x:x1,y:y1};
        var col=counter?'#FF2E4D':'#C9FF2E';
        streak.style.setProperty('--ft-c',col); spark.style.setProperty('--ft-c',col);
        var len=Math.max(40,Math.min(vr.width<560?90:170,Math.abs(x1-x0)*.4));
        streak.style.width=len+'px';
        var phi=Math.atan2(y1-y0,x1-x0)*180/Math.PI-180;
        function tf(x,y,sx){ return 'translate3d('+x.toFixed(1)+'px,'+y.toFixed(1)+'px,0) rotate('+phi.toFixed(1)+'deg) scaleX('+sx+')'; }
        anim(streak,[
          {transform:tf(x0,y0,.2),opacity:0,offset:0},
          {transform:tf(x0+(x1-x0)*.14,y0+(y1-y0)*.14,1),opacity:1,offset:.14},
          {transform:tf(x1,y1,1),opacity:1,offset:.86},
          {transform:tf(x1,y1,.5),opacity:0,offset:1}
        ],{duration:T_TRAVEL,easing:'cubic-bezier(.3,.7,.4,1)',fill:'both'});
      }

      function label(card,txt,cls,i){
        var el=document.createElement('span');
        el.className='dd-ft-dmg'+(cls?' '+cls:''); el.setAttribute('aria-hidden','true'); el.textContent=txt;
        el.style.setProperty('--ft-dx',((i%2?-1:1)*Math.min(16,card.offsetWidth*.07)).toFixed(0)+'px');
        card.appendChild(el);
        var kill=function(){ if(el.parentNode) el.parentNode.removeChild(el); };
        el.addEventListener('animationend',kill);
        setTimeout(kill,1500);
      }

      function impact(h,i){
        var counter=h.kind==='counter';
        var card=counter?hero:npc, bar=counter?heroHp:rivalHp;
        card.classList.toggle('dd-ft-hurt--lite',counter||h.kind==='honest');
        restart(card,'dd-ft-hurt');
        label(card,'-'+h.dmg+' · '+h.name,counter?'dd-ft-dmg--bad':(h.kind==='honest'?'dd-ft-dmg--sm':''),i);
        setHp(bar,h.hp);
        h.row.classList.add('dd-ft-done');
        if(h.pt){
          var x=h.pt.x,y=h.pt.y;
          anim(spark,[
            {transform:'translate3d('+x+'px,'+y+'px,0) scale(.3) rotate(-10deg)',opacity:1,offset:0},
            {transform:'translate3d('+x+'px,'+y+'px,0) scale(1) rotate(0deg)',opacity:1,offset:.4},
            {transform:'translate3d('+x+'px,'+y+'px,0) scale(1.35) rotate(8deg)',opacity:0,offset:1}
          ],{duration:280,easing:'ease-out',fill:'both'});
        }
      }

      /* wait (max 0.9 s) for both pouches so the fight does not start with an empty card (they are loading=lazy) */
      function whenReady(cb){
        var pending=[rivalPack,heroPack].filter(function(im){ return im.tagName==='IMG'&&!im.complete; }); /* inline SVG is always ready */
        if(!pending.length){ cb(); return; }
        var left=pending.length, done=false;
        function fin(){ if(done) return; done=true; cb(); }
        function one(){ if(--left<=0) fin(); }
        pending.forEach(function(im){ im.addEventListener('load',one,{once:true}); im.addEventListener('error',one,{once:true}); });
        setTimeout(fin,900);
      }

      function play(){
        arm();
        running=true; played=true;
        var my0=seq;
        whenReady(function(){ if(my0===seq&&running) go(); });
      }

      function go(){
        var steps=[],n=0;
        function at(t,fn){ steps.push({t:t,fn:fn,n:n++}); }
        at(0,function(){ restart(root,'dd-ft-bn'); });
        at(T_BANNER,function(){ root.classList.remove('dd-ft-bn'); });
        hits.forEach(function(h,i){
          var t=T_BANNER+i*T_STEP;
          at(t,function(){ launch(h,i); });
          at(t+T_IMPACT,function(){ impact(h,i); });
        });
        at(T_BANNER+(hits.length-1)*T_STEP+T_IMPACT+T_TAIL,end);
        steps.sort(function(a,b){ return a.t-b.t||a.n-b.n; });
        var my=seq, t0=performance.now(), k=0;
        (function tick(){
          timer=0;
          if(my!==seq) return;
          var now=performance.now()-t0;
          while(k<steps.length&&steps[k].t<=now){ try{ steps[k].fn(); }catch(e){} k++; }
          if(k<steps.length&&my===seq) timer=setTimeout(tick,Math.max(0,steps[k].t-now));
        })();
      }

      /* warm the cache with the pouch image(s) at idle (loading=lazy) so a jump-scroll or anchor link plays the fight at once; the inline-SVG rival needs none */
      function preload(){ [rivalPack,heroPack].forEach(function(im){ if(im.tagName!=='IMG') return; var u=im.currentSrc||im.src; if(u&&!im.complete){ try{ var pi=new Image(); pi.decoding='async'; pi.src=u; }catch(e){} } }); }
      if(window.requestIdleCallback) window.requestIdleCallback(preload,{timeout:1500}); else setTimeout(preload,1200);

      /* ---- wiring ---- */
      if(rematch) rematch.addEventListener('click',function(e){ e.preventDefault(); if(!running&&!reduced()) play(); });

      if(reduced()||!('IntersectionObserver' in window)){ finalState(); return; }
      root.classList.add('dd-ft-js');
      arm();
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(reduced()){ return; }
          root.classList.toggle('dd-ft-live',e.isIntersecting);
          /* once started the fight always runs to its end (one 4-5 s timeout chain), even if the section scrolls away */
          if(e.isIntersecting&&e.intersectionRatio>=.35&&!played&&!running) play();
        });
      },{threshold:[0,.35],rootMargin:'0px 0px -10% 0px'});
      io.observe(vs);
      if(mql){
        var onRm=function(){ if(reduced()){ io.disconnect(); finalState(); } };
        if(mql.addEventListener) mql.addEventListener('change',onRm); else if(mql.addListener) mql.addListener(onRm);
      }
    }

    function boot(){ try{ init(); }catch(e){} }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
    document.addEventListener('shopify:section:load',boot);
  }catch(e){}
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"40-compare-js":"aa703b3838"});

/* ---- 50-pov.js ---- */
/* ============================================================
   50-pov.js — "How to run it": POV player (workstream E, prefix dd-pv-)
   Four scenes, a step rail that controls them, autoplay while on screen.
   No JS => the rail is a plain list and the viewport shows scene 1's final frame.
   ============================================================ */
(function(){
"use strict";
try{
var root=document.querySelector('[data-dd-pv]');
if(!root) return;
var steps=[].slice.call(root.querySelectorAll('.dd-pv__step'));
var scenes=[].slice.call(root.querySelectorAll('.dd-pv__scene'));
if(steps.length!==4||scenes.length!==4) return;
var grid=root.querySelector('.dd-pv__grid'),
    stage=root.querySelector('.dd-pv__stage'),
    view=root.querySelector('.dd-pv__view'),
    rail=root.querySelector('.dd-pv__rail'),
    pp=root.querySelector('.dd-pv__pp'),
    elClock=root.querySelector('[data-pv-clock]'),
    elNum=root.querySelector('[data-pv-num]'),
    elSub=root.querySelector('[data-pv-sub]'),
    capT=root.querySelector('[data-pv-cap-t]'),
    capEm=root.querySelector('[data-pv-cap-em]'),
    capP=root.querySelector('[data-pv-cap-p]');
var bars=steps.map(function(b){ return b.querySelector('.dd-pv__bar i'); });
var DUR=[4500,5000,4500,4500];     /* scene lengths in ms (scene 2 is a beat longer) */
var HOLD=12000;                     /* pause after any manual interaction */
var mqRM=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
var rm=!!(mqRM&&mqRM.matches);
var i=0,t=0,inView=false,hover=false,userPaused=false,holdUntil=0,holdTimer=0,raf=0,last=0,started=false,subTimer=0;

root.classList.add('dd-pv--js');
if(rm) root.classList.add('dd-pv--rm');

function setBar(k,p){
  if(rm||!bars[k]) return;
  bars[k].style.transform='scaleX('+p.toFixed(3)+')';
}
function restartScene(s){
  if(s._to){ clearTimeout(s._to); s._to=0; }
  s.classList.remove('is-play');
  void s.offsetWidth;                       /* reflow: restart the CSS animations */
  if(!rm) s.classList.add('is-play');
}
function setHud(n){
  var b=steps[n];
  if(elClock) elClock.textContent=b.getAttribute('data-clock')||'';
  if(elNum) elNum.textContent=('0'+(n+1)).slice(-2);
  var txt=b.getAttribute('data-sub')||'';
  if(elSub){
    clearTimeout(subTimer);
    if(rm||!started){ elSub.textContent=txt; elSub.classList.remove('is-swap'); }
    else{
      elSub.classList.add('is-swap');
      subTimer=setTimeout(function(){ elSub.textContent=txt; elSub.classList.remove('is-swap'); },160);
    }
  }
  var tt=b.querySelector('.dd-pv__t'),em=b.querySelector('.dd-pv__em'),ins=b.querySelector('.dd-pv__ins');
  if(capT&&tt) capT.textContent=tt.textContent;
  if(capEm&&em) capEm.textContent=em.textContent;
  if(capP&&ins) capP.textContent=ins.textContent;
}
function show(n){
  i=n; t=0;
  steps.forEach(function(b,k){
    if(k===n) b.setAttribute('aria-current','step'); else b.removeAttribute('aria-current');
    setBar(k,0);
  });
  scenes.forEach(function(s,k){
    if(k===n){ restartScene(s); s.classList.add('is-on'); }
    else if(s.classList.contains('is-on')){
      s.classList.remove('is-on');
      s._to=setTimeout(function(){ s._to=0; if(!s.classList.contains('is-on')) s.classList.remove('is-play'); },450);
    }
  });
  setHud(n);
}
function canPlay(){
  return !rm && inView && !document.hidden && !hover && !userPaused && Date.now()>=holdUntil;
}
function tick(now){
  raf=0;
  if(!canPlay()) return;
  var dt=Math.min(now-last,100); last=now; t+=dt;
  setBar(i,Math.min(t/DUR[i],1));
  if(t>=DUR[i]) show((i+1)%4);
  raf=requestAnimationFrame(tick);
}
function sync(){
  root.classList.toggle('dd-pv--idle',!inView||document.hidden);
  if(canPlay()){
    if(!raf){ last=performance.now(); raf=requestAnimationFrame(tick); }
  }else if(raf){ cancelAnimationFrame(raf); raf=0; }
}
function manual(){
  holdUntil=Date.now()+HOLD;
  clearTimeout(holdTimer);
  holdTimer=setTimeout(function(){
    holdUntil=0;
    if(t<DUR[i]-1200){ t=DUR[i]-1200; setBar(i,t/DUR[i]); }   /* they have had their 12 s: move on soon */
    sync();
  },HOLD+40);
  sync();
}
function go(n,fromUser){
  n=((n%4)+4)%4;
  started=true;
  show(n);
  if(fromUser!==false) manual();
}

/* rail: click + arrow keys */
steps.forEach(function(b,k){
  b.addEventListener('click',function(){ go(k); });
});
if(rail) rail.addEventListener('keydown',function(e){
  var k=steps.indexOf(document.activeElement);
  if(k<0) return;
  var to=-1;
  if(e.key==='ArrowRight') to=Math.min(k+1,3);
  else if(e.key==='ArrowLeft') to=Math.max(k-1,0);
  else if(e.key==='Home') to=0;
  else if(e.key==='End') to=3;
  if(to<0) return;
  e.preventDefault();
  steps[to].focus();
  go(to);
});

/* play / pause */
if(pp){
  pp.hidden=false;
  if(rm) pp.hidden=true;
  pp.addEventListener('click',function(){
    userPaused=!userPaused;
    pp.setAttribute('aria-pressed',userPaused?'true':'false');
    sync();
  });
}

/* pointer over the player pauses autoplay (mouse only) */
if(grid){
  grid.addEventListener('pointerenter',function(e){ if(e.pointerType==='mouse'){ hover=true; sync(); } });
  grid.addEventListener('pointerleave',function(e){ if(e.pointerType==='mouse'){ hover=false; sync(); } });
}

/* swipe on the viewport (horizontal only; vertical drags scroll the page) */
if(view){
  var sx=0,sy=0,sid=-1;
  view.addEventListener('pointerdown',function(e){ sid=e.pointerId; sx=e.clientX; sy=e.clientY; });
  view.addEventListener('pointercancel',function(){ sid=-1; });
  view.addEventListener('pointerup',function(e){
    if(e.pointerId!==sid) return;
    sid=-1;
    var dx=e.clientX-sx,dy=e.clientY-sy;
    if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.3) go(i+(dx<0?1:-1));
  });
}

/* on screen? (>=50% of the viewport) */
if('IntersectionObserver' in window&&stage){
  new IntersectionObserver(function(es){
    var e=es[es.length-1];
    inView=e.isIntersecting&&e.intersectionRatio>=0.5;
    if(inView&&!started){ started=true; show(i); }   /* first time on screen: play scene 1 from the top */
    sync();
  },{threshold:[0,0.25,0.5,0.75,1]}).observe(stage);
}else{ inView=true; started=true; show(0); sync(); }
document.addEventListener('visibilitychange',sync);

/* reduced motion can change while the page is open */
if(mqRM){
  var onRM=function(){
    rm=mqRM.matches;
    root.classList.toggle('dd-pv--rm',rm);
    if(pp) pp.hidden=rm;
    bars.forEach(function(b){ if(b) b.style.transform=''; });
    scenes.forEach(function(s){ s.classList.remove('is-play'); });
    show(i);
    sync();
  };
  if(mqRM.addEventListener) mqRM.addEventListener('change',onRM); else if(mqRM.addListener) mqRM.addListener(onRM);
}

setHud(0);
sync();

/* small helper for tests / other scripts */
window.__ddPov={
  go:function(n){ go(n|0); },
  index:function(){ return i; },
  state:function(){ return {i:i,t:Math.round(t),inView:inView,hover:hover,userPaused:userPaused,hold:holdUntil>Date.now(),rm:rm,playing:canPlay()}; }
};
}catch(err){ if(window.console&&console.warn) console.warn('[dd-pv]',err); }
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"50-pov-js":"0fe4c1c96c"});

/* ---- 60-pdp-cart.js ---- */
/* ============================================================
   60-pdp-cart.js — workstream R2-4a (15 Oct 2026)
   1. Product page: the "Full pack info" <details id="pack-info"> opens itself when the URL hash is #pack-info
      (on load and on hashchange), and the nav's "Tap to RESPAWN" button scrolls to the purchase panel.
   2. Cart page: the Death Squad upsell ("Switch & save") re-plans the Solo Run line through /cart/change.js and reloads.
   3. (R3-3, 15 Oct) Mobile sticky CTA bar, home + product page only (second IIFE at the end of this file).
   4. (v10 X3b, 18 Oct 2026) Cart page: the delivery row ([data-dd-dc="cart"] in snippets/cart-summary.liquid) shows the live dispatch
      cut-off + estimated arrival, from window.ddDispatch (30-order.js) with a local copy of the same rules if that is missing.
   Runs on every template (home, product, cart, 404): every query is guarded. Delegated listeners only, because the
   cart section is re-rendered (morphed) by Horizon whenever a quantity changes.
   ============================================================ */
(function(){
"use strict";
try{
  var RM=!!(window.DDv9&&window.DDv9.RM);

  /* ---- 1a. #pack-info opens itself ---- */
  function openPack(){
    try{
      if(location.hash!=='#pack-info') return;
      var d=document.getElementById('pack-info');
      if(d&&d.tagName==='DETAILS'&&!d.open){
        d.open=true;
        // the page jumped to the closed summary; settle on it once the body has its height
        setTimeout(function(){ try{ d.scrollIntoView({block:'start',behavior:'auto'}); }catch(e){} },30);
      }
    }catch(e){}
  }
  openPack();
  window.addEventListener('hashchange',openPack);
  window.addEventListener('pageshow',openPack);

  /* ---- 1b. nav CTA on the product page: take the shopper to the plan picker, not the top of the page ---- */
  document.addEventListener('click',function(ev){
    try{
      var a=ev.target&&ev.target.closest&&ev.target.closest('.dd-nav__cta');
      if(!a) return;
      var buy=document.querySelector('.dd-pc-buy');
      var href=a.getAttribute('href')||'';
      if(!buy||href.charAt(0)!=='#') return;          // only where the nav button is an in-page link (product page)
      ev.preventDefault();
      /* W-9 (28 Oct 2026): scroll to the plan cards (#order-plans) so the plans and the button are on screen under the header */
      (document.getElementById('order-plans')||buy).scrollIntoView({block:'start',behavior:RM?'auto':'smooth'});
      if(history&&history.replaceState){ try{ history.replaceState(null,'',href); }catch(e){} }
    }catch(e){}
  });

  /* ---- 2. cart upsell: Solo Run -> Death Squad ---- */
  document.addEventListener('click',function(ev){
    try{
      var b=ev.target&&ev.target.closest&&ev.target.closest('[data-dd-pc-switch]');
      if(!b||b.disabled) return;
      ev.preventDefault();
      var box=b.closest('[data-dd-pc-up]');
      var err=box&&box.querySelector('.dd-pc-up__err');
      var label=b.textContent;
      function fail(msg){
        b.disabled=false; b.textContent=label;
        if(err){ err.textContent=msg||'Couldn’t switch just now. Please try again in a moment.'; err.hidden=false; }
      }
      if(err){ err.hidden=true; err.textContent=''; }
      b.disabled=true; b.textContent='Switching…';
      var body={id:b.getAttribute('data-key'),quantity:parseInt(b.getAttribute('data-qty'),10)||1,selling_plan:parseInt(b.getAttribute('data-plan'),10)||692976451932};
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
        .then(function(r){ return r.json().then(function(j){ return {ok:r.ok,j:j}; },function(){ return {ok:r.ok,j:{}}; }); })
        .then(function(res){
          var j=res.j||{};
          if(!res.ok||j.status>=400||j.errors){
            fail();
            return;
          }
          b.textContent='Switched ✓';
          window.location.reload();
        })
        .catch(function(){ fail(); });
    }catch(e){}
  });
}catch(err){}
})();

/* ============================================================
   3. MOBILE STICKY CTA (R3-3, 15 Oct 2026) — home + product page, viewport <= 899px (CSS hides it above that).
   A fixed bar: "RESPAWN / Free UK delivery" on the left, a lime "Tap to RESPAWN" button on the right that scrolls to the
   purchase area (#order; on the product page straight to the plan picker inside it, like the nav button does).
   Shown only while ALL of these hold (IntersectionObserver, so it works whichever element scrolls):
     - the visitor has scrolled PAST the page's primary CTA (home: .dd-hero__cta, product page: #buy): the CTA is off
       screen AND its bottom edge is above the top of the viewport (R4-X, 16 Oct 2026: while the CTA is still below the
       fold the bar stays hidden, so it no longer shows on first load)
     - #order is not on screen
     - the footer is not on screen
   plus two courtesy rules: it steps aside while a modal dialog (the gallery lightbox) is open, and while one of the
   page's loop/tour controls (squad pause + Meet the squad, POV pause, loadout tour pause) sit in the strip the bar covers.
   z-index 400: above the page, below the lightbox (10000) and far below Shopify's cookie banner.
   Styles: 60-pdp-cart.css (.dd-pc-sticky). Reduced motion: no slide, no smooth scroll.
   ============================================================ */
;(function(){
"use strict";
try{
  var doc=document;
  if(!window.IntersectionObserver||!doc.body) return;
  var mq=window.matchMedia?window.matchMedia('(max-width:899px)'):null;
  var rmq=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
  var mode='home', cta=doc.querySelector('.dd-hero__cta');
  if(!cta){
    mode='pdp'; cta=doc.getElementById('buy');
    if(cta&&!doc.querySelector('.dd-pc-pdp')) cta=null;
  }
  var order=doc.getElementById('order');
  var foot=doc.querySelector('.dd-foot')||doc.querySelector('footer');
  if(!cta||!order||doc.getElementById('dd-pc-sticky')) return;

  var bar=doc.createElement('div');
  bar.className='dd-pc-sticky'; bar.id='dd-pc-sticky';
  bar.setAttribute('role','region'); bar.setAttribute('aria-label','Quick buy');
  bar.innerHTML='<div class="dd-pc-sticky__t"><b>RESPAWN</b><span>Free UK delivery</span></div>'+
    '<a class="dd-btn dd-pc-sticky__btn" href="#order-plans">Tap to RESPAWN</a>';
  doc.body.appendChild(bar);

  var on={cta:true,order:true,foot:false,keep:false,modal:false}, seen={cta:false,order:false}, past=false;
  function apply(){
    var show=seen.cta&&seen.order&&past&&!on.cta&&!on.order&&!on.foot&&!on.keep&&!on.modal&&(!mq||mq.matches);
    if(bar.classList.contains('is-on')!==!!show) bar.classList.toggle('is-on',!!show);
  }

  /* the three conditions */
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){
      var k=e.target===cta?'cta':(e.target===order?'order':'foot');
      on[k]=!!e.isIntersecting; seen[k]=true;
      if(k==='cta'){
        /* "past" = off screen with its bottom above the viewport top. A CTA that is not rendered at all (zero box) can't be
           scrolled past, so it falls back to the old rule (off screen = past). */
        var br=e.boundingClientRect, top=e.rootBounds?e.rootBounds.top:0;
        past=!e.isIntersecting&&((!br.width&&!br.height)||br.bottom<=top);
      }
    });
    apply();
  },{threshold:0});
  io.observe(cta); io.observe(order); if(foot&&foot!==order) io.observe(foot);

  /* a modal dialog (the gallery lightbox: role=dialog aria-modal=true, toggled with [hidden]) is up */
  function dialogUp(){
    try{
      if(doc.documentElement.classList.contains('dd-ob-lock')) return true;
      var n=doc.querySelectorAll('[role="dialog"][aria-modal="true"]');
      for(var i=0;i<n.length;i++){
        var e=n[i]; if(e.hidden) continue;
        var cs=window.getComputedStyle(e);
        if(cs.display!=='none'&&cs.visibility!=='hidden') return true;
      }
    }catch(err){}
    return false;
  }
  var raf=0;
  function checkModal(){
    if(raf) return;
    raf=window.requestAnimationFrame(function(){
      raf=0; var m=dialogUp();
      if(m!==on.modal){ on.modal=m; apply(); }
    });
  }
  if(window.MutationObserver){
    var mo=new MutationObserver(checkModal);
    mo.observe(doc.body,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','open','aria-modal','role']});
    mo.observe(doc.documentElement,{attributes:true,attributeFilter:['class']});
  }
  checkModal();

  /* courtesy: step aside while a loop / tour control would sit under the bar */
  var KEEP='.dd-sq2-bar,.dd-lo-auto,.dd-pv__pp';
  var yio=null, hits={}, uid=0, rt=0;
  function watchKeep(){
    try{
      if(yio){ yio.disconnect(); yio=null; }
      hits={}; on.keep=false;
      var els=doc.querySelectorAll(KEEP);
      if(!els.length){ apply(); return; }
      var vh=doc.documentElement.clientHeight||window.innerHeight||800;
      var h=(bar.offsetHeight||76)+6;
      yio=new IntersectionObserver(function(es){
        es.forEach(function(e){
          var id=e.target.__ddk||(e.target.__ddk=++uid);
          if(e.isIntersecting) hits[id]=1; else delete hits[id];
        });
        on.keep=Object.keys(hits).length>0; apply();
      },{rootMargin:'-'+Math.max(0,vh-h)+'px 0px 0px 0px',threshold:0});
      for(var i=0;i<els.length;i++) yio.observe(els[i]);
    }catch(err){}
  }
  function later(){ clearTimeout(rt); rt=setTimeout(watchKeep,200); }
  watchKeep();
  window.addEventListener('resize',later);
  window.addEventListener('orientationchange',later);
  window.addEventListener('pageshow',later);
  if(mq){ if(mq.addEventListener) mq.addEventListener('change',function(){ apply(); later(); }); else if(mq.addListener) mq.addListener(function(){ apply(); later(); }); }

  /* the button */
  bar.addEventListener('click',function(ev){
    try{
      var a=ev.target&&ev.target.closest&&ev.target.closest('.dd-pc-sticky__btn');
      if(!a) return;
      ev.preventDefault();
      /* W-9 (28 Oct 2026): land on the plan cards (#order-plans, header offset from scroll-padding/-margin), not the section top */
      var t=doc.getElementById('order-plans')||(mode==='pdp'&&doc.querySelector('.dd-pc-buy'))||order;
      t.scrollIntoView({block:'start',behavior:(rmq&&rmq.matches)?'auto':'smooth'});
    }catch(err){}
  });
}catch(err){}
})();

/* ============================================================
   4. CART DISPATCH ROW (v10 X3b) — "Order within 2h 14m — dispatched today" / "Dispatched Monday" + "Est. arrival Tue 20 – Wed 21 Oct".
   Same rules as 30-order.js (2pm cut-off, working days, Europe/London, England & Wales bank holidays); uses window.ddDispatch when it
   exists, else the local copy below. Horizon re-renders (morphs) the cart section on every quantity change, so a MutationObserver
   repaints any fresh [data-dd-dc="cart"] node at once. Updates every 30s, paused while the tab is hidden.
   ============================================================ */
;(function(){
"use strict";
try{
  var doc=document;
  if(!window.Intl||!Intl.DateTimeFormat) return;
  var info=null;
  if(window.ddDispatch&&typeof window.ddDispatch.info==='function') info=window.ddDispatch.info;
  else{
    /* local fallback copy of 30-order.js section 5 (keep the two in step; extend the bank holiday list every year) */
    var BH={'2026-12-25':1,'2026-12-28':1,'2027-01-01':1,'2027-03-26':1,'2027-03-29':1,'2027-05-03':1,'2027-05-31':1,'2027-08-30':1,'2027-12-27':1,'2027-12-28':1};
    var DAYS=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'], MONS=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var CUT=14*3600, OFF=0, fmt=null;
    try{
      var q=new URLSearchParams(window.location.search).get('ddnow');
      if(q&&((window.Shopify&&window.Shopify.designMode)||/[?&]preview_theme_id=/.test(window.location.search))){ var t=Date.parse(q); if(isFinite(t)) OFF=t-Date.now(); }
    }catch(e){}
    var p2=function(n){ return n<10?'0'+n:''+n; };
    var dn=function(y,m,d){ return Math.round(Date.UTC(y,m-1,d)/864e5); };
    var ymd=function(n){ var x=new Date(n*864e5); return {y:x.getUTCFullYear(),m:x.getUTCMonth()+1,d:x.getUTCDate(),w:x.getUTCDay()}; };
    var isWork=function(n){ var x=ymd(n); return x.w>0&&x.w<6&&!BH[x.y+'-'+p2(x.m)+'-'+p2(x.d)]; };
    var addWork=function(n,k){ while(k>0){ n++; if(isWork(n)) k--; } return n; };
    var short=function(n){ var x=ymd(n); return DAYS[x.w].slice(0,3)+' '+x.d; };
    info=function(ms){
      try{
        if(!fmt) fmt=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',minute:'numeric',second:'numeric',hourCycle:'h23'});
        var o={}; fmt.formatToParts(new Date(ms==null?Date.now()+OFF:ms)).forEach(function(x){ o[x.type]=parseInt(x.value,10); });
        var s=(o.hour%24)*3600+o.minute*60+o.second, t0=dn(o.year,o.month,o.day), same=isWork(t0)&&s<CUT;
        var disp=same?t0:addWork(t0,1), diff=disp-t0, word, mins=same?Math.ceil((CUT-s)/60):0;
        if(diff===0) word='today'; else if(diff===1) word='tomorrow'; else if(diff<=6) word=DAYS[ymd(disp).w]; else word=short(disp)+' '+MONS[ymd(disp).m-1];
        var a=addWork(disp,1), b=addWork(disp,2), x=ymd(a), y=ymd(b), h=Math.floor(mins/60), m=mins%60;
        return {today:same,mins:mins,left:same?(h?(m?h+'h '+m+'m':h+'h'):m+'m'):'',word:word,
                arrival:short(a)+(x.m!==y.m?' '+MONS[x.m-1]:'')+' – '+short(b)+' '+MONS[y.m-1]};
      }catch(e){ return null; }
    };
  }

  function paint(el){
    var i=info(); if(!i) return;
    var head=i.today?'Order within '+i.left+' — dispatched today':'Dispatched '+i.word;
    var sub='Est. arrival '+i.arrival;
    var key=head+'|'+sub+'|'+(i.today?1:0);
    if(el.getAttribute('data-dd-k')===key) return;
    el.setAttribute('data-dd-k',key);
    el.textContent='';
    var b=doc.createElement('b');
    if(i.today){ var dot=doc.createElement('i'); dot.className='dd-dc-dot'; dot.setAttribute('aria-hidden','true'); b.appendChild(dot); }
    b.appendChild(doc.createTextNode(head));
    var sm=doc.createElement('small'); sm.textContent=sub;
    el.appendChild(b); el.appendChild(sm);
  }
  var lio=null;
  function run(){
    var els=doc.querySelectorAll('[data-dd-dc="cart"]');
    for(var k=0;k<els.length;k++){
      paint(els[k]);
      if(!els[k].__ddLive){
        els[k].__ddLive=1;
        if('IntersectionObserver' in window){
          lio=lio||new IntersectionObserver(function(es){ es.forEach(function(e){ e.target.classList.toggle('dd-dc-live',e.isIntersecting); }); },{rootMargin:'40px 0px'});
          lio.observe(els[k]);
        }else els[k].classList.add('dd-dc-live');
      }
    }
    return els.length;
  }
  if(!run()&&!doc.querySelector('.cart-page,[data-template="cart"]')) return;   // nothing to do on other pages
  var timer=0;
  function stop(){ if(timer){ clearInterval(timer); timer=0; } }
  function go(){ stop(); run(); timer=setInterval(run,30000); }
  if(!doc.hidden) go();
  doc.addEventListener('visibilitychange',function(){ if(doc.hidden) stop(); else go(); });
  if(window.MutationObserver&&doc.body){
    var pend=0;
    new MutationObserver(function(){
      if(pend) return;
      pend=window.requestAnimationFrame(function(){
        pend=0;
        var n=doc.querySelectorAll('[data-dd-dc="cart"]');
        for(var k=0;k<n.length;k++){ if(!n[k].__ddLive||!n[k].hasAttribute('data-dd-k')){ run(); break; } }
      });
    }).observe(doc.body,{childList:true,subtree:true});
  }
}catch(err){}
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"60-pdp-cart-js":"123bcbbd0a"});

/* ---- 65-pages.js ---- */
/* R2-4b (15 Oct 2026) — contact page behaviour (sections/respawn-contact.liquid). Own IIFE, guarded, never throws.
   1) After a post (success panel or error summary rendered by Liquid) move focus to it so it is announced and in view.
   2) On a valid submit show a busy state on the button so the message is not sent twice. Never auto-submits anything. */
;(function(){
  try{
    var form=document.getElementById('dd-pg-ct-form');
    if(!form) return;
    var msg=form.querySelector('[data-dd-pg-focus]');
    if(msg){
      setTimeout(function(){
        try{ msg.focus(); }catch(e){}
        try{ msg.scrollIntoView({block:'center'}); }catch(e){}
      },60);
    }
    var btn=form.querySelector('button[type="submit"]');
    if(!btn) return;
    var label=btn.textContent;
    function reset(){ try{ btn.disabled=false; btn.removeAttribute('aria-busy'); btn.textContent=label; }catch(e){} }
    form.addEventListener('submit',function(){
      try{
        if(form.checkValidity && !form.checkValidity()) return;
        btn.setAttribute('aria-busy','true');
        setTimeout(function(){ btn.disabled=true; btn.textContent='Sending…'; },0);
      }catch(e){}
    });
    window.addEventListener('pageshow',function(ev){ if(ev.persisted) reset(); });
  }catch(e){}
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"65-pages-js":"c4af75edb5"});

/* ---- 70-roster.js ---- */
/* ============================================================
   70-roster.js — "Meet the squad" character select (R2-5, 15 Oct 2026, prefix dd-ro-)
   Markup: sections/respawn-roster.liquid. The first member is server-rendered active; this script wires the 5 tiles (4 members + squad ult).
   - auto-cycles every 5 s until the first interaction (pointer, touch, key, focus); no auto-cycle with reduced motion, off-screen or in a hidden tab
   - ArrowLeft/Right move the selection while the section is on screen; ArrowUp/Down/Home/End when focus is on a tile
   - tiles are buttons (aria-pressed); the active card is the accessible content (inactive ones get aria-hidden)
   Safe on every template: returns at once when the section is not there.
   ============================================================ */
(function () {
  try {
    var root = document.querySelector('[data-ro]');
    if (!root) return;
    var tiles = [].slice.call(root.querySelectorAll('[data-ro-tile]'));
    var cards = [].slice.call(root.querySelectorAll('[data-ro-m]'));
    var row = root.querySelector('[data-ro-sel]');
    var stage = root.querySelector('[data-ro-stage]');
    var n = cards.length;
    if (!n || tiles.length !== n) return;

    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    function reduced() { return !!((window.DDv9 && window.DDv9.RM) || (mq && mq.matches)); }

    var cur = 0, touched = false, timer = 0, inView = false, shown = !document.hidden;
    for (var k = 0; k < n; k++) { if (cards[k].classList.contains('is-active')) { cur = k; break; } }

    function centre(i, smooth) {
      try {
        var t = tiles[i];
        if (!row || !t || row.scrollWidth <= row.clientWidth + 2) return;
        var left = t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2;
        if (row.scrollTo) row.scrollTo({ left: left, behavior: smooth && !reduced() ? 'smooth' : 'auto' });
        else row.scrollLeft = left;
      } catch (e) {}
    }

    function select(i, byUser) {
      i = ((i % n) + n) % n;
      if (i === cur && cards[i].classList.contains('is-active')) return;
      cur = i;
      for (var j = 0; j < n; j++) {
        var on = j === i;
        cards[j].classList.toggle('is-active', on);
        if (on) cards[j].removeAttribute('aria-hidden'); else cards[j].setAttribute('aria-hidden', 'true');
        tiles[j].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      root.classList.add('dd-ro--live');
      centre(i, byUser);
    }

    function stop() { if (timer) { clearInterval(timer); timer = 0; } }
    function start() {
      stop();
      if (touched || reduced() || !inView || !shown) return;
      timer = setInterval(function () { select(cur + 1, false); }, 5000);
    }
    function touch() {
      if (touched) return;
      touched = true; stop();
      if (stage) stage.setAttribute('aria-live', 'polite');
    }

    tiles.forEach(function (t, i) {
      t.addEventListener('click', function () { touch(); select(i, true); });
    });
    ['pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
      root.addEventListener(ev, touch, { passive: true });
    });

    function onTile(el) { return !!(el && el.closest && el.closest('[data-ro-tile]')); }
    function typing(el) {
      if (!el || !el.tagName) return false;
      var tg = el.tagName;
      return tg === 'INPUT' || tg === 'TEXTAREA' || tg === 'SELECT' || el.isContentEditable;
    }
    document.addEventListener('keydown', function (e) {
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      var key = e.key, d = 0, abs = -1;
      if (key === 'ArrowRight') d = 1;
      else if (key === 'ArrowLeft') d = -1;
      else if ((key === 'ArrowDown' || key === 'ArrowUp' || key === 'Home' || key === 'End') && onTile(e.target)) {
        if (key === 'ArrowDown') d = 1; else if (key === 'ArrowUp') d = -1; else abs = key === 'Home' ? 0 : n - 1;
      } else return;
      if (typing(e.target)) return;
      var inside = root.contains(e.target);
      if (!inside && !inView) return;
      touch();
      select(abs >= 0 ? abs : cur + d, true);
      if (onTile(e.target) && tiles[cur].focus) tiles[cur].focus({ preventScroll: true });
      e.preventDefault();
    });

    document.addEventListener('visibilitychange', function () { shown = !document.hidden; start(); });
    if (mq && mq.addEventListener) mq.addEventListener('change', function () { start(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          inView = en.isIntersecting;
          root.classList.toggle('dd-ro--off', !inView);
          start();
        });
      }, { threshold: 0.2 }).observe(root.querySelector('.dd-ro__grid') || root);
    } else { inView = true; start(); }

    centre(cur, false);
  } catch (err) { /* never break the page */ }
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"70-roster-js":"895f94a425"});

/* ---- 90-pop.js ---- */
/* ============================================================
   90-pop.js — Squad comms slide-in + phone tier-list collapse (24 Oct 2026, request 2026-10-24-02)
   Pop rules: once per 14 days (localStorage dd_pop_t), never after sign-up (dd_pop_done), never on the first screen,
   desktop exit intent after 12s or 60% scroll after 20s, phones 60% scroll after 20s. Esc / × closes it.
   W-9 (28 Oct 2026): below 900px it never shows on the product page and never while the sticky buy bar (#dd-pc-sticky.is-on) is up
   (the two stacked: header 62 + slide-in 219 + bar 69 = 41% of an 844px phone); the check repeats every tick, so it appears
   once the bar steps aside. Depth threshold 55% -> 60%. Dismissal memory (dd_pop_t / dd_pop_done) unchanged.
   If the page reloads after submitting it (Shopify's form post), the result is shown straight away.
   Events: dd_pop {action:'view'|'close'}, dd_signup {source:'popup'}. Test hook: window.__ddPop.show()
   ============================================================ */
(function(){
"use strict";
var pub=function(n,d){ try{ if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish) Shopify.analytics.publish(n,d||{}); }catch(e){} };
var ls={get:function(k){ try{ return localStorage.getItem(k); }catch(e){ return null; } },set:function(k,v){ try{ localStorage.setItem(k,v); }catch(e){} }};

/* tier list collapse */
try{
  [].forEach.call(document.querySelectorAll('[data-tbl-short]'),function(t){
    var b=t.parentNode.querySelector('[data-tbl-more]'); if(!b) return;
    t.classList.add('is-short'); b.hidden=false;
    b.addEventListener('click',function(){ t.classList.remove('is-short'); b.hidden=true; });
  });
}catch(e){}

/* cart: switch a Solo Run line to the Death Squad plan (same key, same quantity) */
document.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('[data-dd-up-b]'); if(!b) return;
  var w=b.closest('[data-dd-up]'); if(!w||b.getAttribute('aria-busy')==='true') return;
  b.setAttribute('aria-busy','true'); b.textContent='Switching…';
  fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({id:w.getAttribute('data-key'),quantity:+w.getAttribute('data-qty')||1,selling_plan:+w.getAttribute('data-plan')})})
  .then(function(r){ if(!r.ok) throw 0; pub('dd_cart_upgrade',{to:'squad'}); location.reload(); })
  .catch(function(){ b.removeAttribute('aria-busy'); b.textContent='Try again'; });
});

/* hero battle pause control (25 Oct, WCAG 2.2.2) — shown only when the battle animates */
try{
  var hp=document.querySelector('[data-hx-pause]');
  if(hp&&!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)){
    var tries=0,iv=setInterval(function(){
      if(window.__ddPx&&window.__ddPx.pause){ clearInterval(iv); hp.hidden=false;
        hp.addEventListener('click',function(e){ e.stopPropagation(); var on=hp.getAttribute('aria-pressed')!=='true';
          window.__ddPx.pause(on); hp.setAttribute('aria-pressed',String(on)); hp.setAttribute('aria-label',on?'Play the battle animation':'Pause the battle animation'); pub('dd_game',{action:on?'pause':'play'}); });
      } else if(++tries>40) clearInterval(iv);
    },250);
  }
}catch(e){}

/* footer link groups: collapsed on phones */
try{
  if(window.matchMedia&&matchMedia('(max-width:760px)').matches)
    [].forEach.call(document.querySelectorAll('[data-foot-acc]'),function(d){ d.open=false; });
}catch(e){}

/* slide-in */
try{
  var pop=document.querySelector('[data-dd-pop]'); if(!pop) return;
  var DAY=864e5, now=Date.now();
  function show(){
    if(!pop.hidden) return;
    pop.hidden=false; requestAnimationFrame(function(){ pop.classList.add('is-in'); });
    ls.set('dd_pop_t',String(Date.now())); pub('dd_pop',{action:'view'});
    off();
  }
  function hide(){ pop.classList.remove('is-in'); setTimeout(function(){ pop.hidden=true; },300); pub('dd_pop',{action:'close'}); }
  pop.querySelector('[data-dd-pop-x]').addEventListener('click',hide);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!pop.hidden) hide(); });
  var f=pop.querySelector('form');
  if(f) f.addEventListener('submit',function(){ ls.set('dd_pop_done','1'); pub('dd_signup',{source:'popup'}); });
  window.__ddPop={show:show};

  /* returning from the form post: show the result */
  if(pop.querySelector('[data-dd-pop-ok],[data-dd-pop-err]')&&/customer_posted|contact_posted|form_type=customer/.test(location.href+document.referrer)){
    pop.hidden=false; pop.classList.add('is-in'); return;
  }
  if(ls.get('dd_pop_done')) return;
  var last=+ls.get('dd_pop_t')||0; if(now-last<14*DAY) return;

  var t0=now, armed=true;
  function engaged(ms){ return Date.now()-t0>=ms; }
  function depth(){
    var se=document.scrollingElement||document.documentElement, pw=document.querySelector('.page-wrapper');
    var y=Math.max(se.scrollTop,pw?pw.scrollTop:0), h=Math.max(se.scrollHeight,pw?pw.scrollHeight:0)-innerHeight;
    return h>0?y/h:0;
  }
  /* never while the footer's own Squad comms form is on screen (it would ask twice) */
  function footVisible(){ var fc=document.getElementById('squad-comms'); if(!fc) return false; var r=fc.getBoundingClientRect(); return r.top<innerHeight&&r.bottom>0; }
  /* W-9: phones (< 900px) only: not on the product page, not while the sticky buy bar is showing */
  var phone=window.matchMedia?matchMedia('(max-width:899px)'):null;
  var onPdp=!!document.querySelector('.dd-pc-pdp')||/^\/products\//.test(location.pathname);
  function phoneBlocked(){
    if(!phone||!phone.matches) return false;
    if(onPdp) return true;
    var sb=document.getElementById('dd-pc-sticky'); return !!(sb&&sb.classList.contains('is-on'));
  }
  function onScroll(){ if(armed&&engaged(20000)&&depth()>.60&&!footVisible()&&!phoneBlocked()) show(); }
  function onOut(e){ if(armed&&!e.relatedTarget&&e.clientY<=0&&engaged(12000)&&!footVisible()&&!phoneBlocked()) show(); }
  var tick=setInterval(onScroll,1500);
  function off(){ armed=false; clearInterval(tick); document.removeEventListener('mouseout',onOut); }
  if(window.matchMedia&&matchMedia('(hover: hover) and (pointer: fine)').matches) document.addEventListener('mouseout',onOut);
}catch(e){}
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"90-pop-js":"82e0988f70"});

/* ---- 95-consent.js ---- */
/* 95-consent — cookie choices (25 Oct 2026, request 2026-10-25-07).
   1. Footer "Cookie preferences" button: shown only when Shopify's consent banner is on the page
      (window.privacyBanner.showPreferences), so a visitor can change or withdraw consent as easily as they gave it.
   2. Clarity consent bridge: passes the visitor's Shopify choice to Microsoft Clarity (consentv2), so Clarity
      only sets cookies after "Accept" and goes back to cookieless after a withdrawal. */
(function(){
try{
  var w=window,d=document;

  function prefsApi(){ return w.privacyBanner&&typeof w.privacyBanner.showPreferences==='function'; }
  function wirePrefs(){
    var bs=d.querySelectorAll('[data-dd-cookie-prefs]');
    if(!bs.length) return true;
    if(!prefsApi()) return false;
    for(var i=0;i<bs.length;i++){
      var b=bs[i], li=b.closest('li');
      if(li) li.hidden=false;
      b.hidden=false;
      if(!b.__dd){ b.__dd=1; b.addEventListener('click',function(){ try{ w.privacyBanner.showPreferences(); }catch(e){} }); }
    }
    return true;
  }

  function toClarity(){
    var cp=w.Shopify&&w.Shopify.customerPrivacy;
    if(!cp||typeof cp.currentVisitorConsent!=='function') return false;
    var c=cp.currentVisitorConsent()||{};
    if(c.analytics!=='yes'&&c.analytics!=='no') return true; /* no choice yet: Clarity stays cookieless */
    w.clarity=w.clarity||function(){(w.clarity.q=w.clarity.q||[]).push(arguments);};
    w.clarity('consentv2',{
      ad_Storage: c.marketing==='yes'?'granted':'denied',
      analytics_Storage: c.analytics==='yes'?'granted':'denied'
    });
    return true;
  }

  d.addEventListener('visitorConsentCollected',function(){ try{ toClarity(); }catch(e){} });

  var tries=0;
  (function poll(){
    var a=false,b=false;
    try{ a=wirePrefs(); }catch(e){ a=true; }
    try{ b=toClarity(); }catch(e){ b=true; }
    if((a&&b)||++tries>20) return;
    setTimeout(poll,500);
  })();
}catch(e){}
})();

;(window.DDv9=window.DDv9||{}).parts=Object.assign((window.DDv9||{}).parts||{},{"95-consent-js":"c0c7bce1c6"});
